import React from 'react';
import '../globals.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ProgressItem {
  percentage: number;
  valueText: string;
  labelKey: string;
}

const CountryList: React.FC = () => {
  const { t } = useTranslation();

  const progressItems: ProgressItem[] = [
    { percentage: 95, valueText: '95%', labelKey: 'satisfied_clients' },
    { percentage: 8, valueText: '8%', labelKey: 'global_presence' },
    { percentage: 10, valueText: '10%', labelKey: 'years_experience' },
    { percentage: 40, valueText: '40%', labelKey: 'hidden_cost' },
  ];

  return (
    <section className="country_list">
      <div className="container">
        <div className="row">
          <div className="col-md-5">
            {progressItems.map((item, index) => (
              <div className="progress_details" key={index}>
                <div
                  className={`progress ${item.percentage > 50 ? 'over50' : ''}`}
                  data-percentage={item.percentage}
                >
                  <span className="progress-left">
                    <span className="progress-bar"></span>
                  </span>
                  <span className="progress-right">
                    <span className="progress-bar"></span>
                  </span>
                  <div className="progress-value">
                    <div>
                      {item.valueText}
                      <br />
                    </div>
                  </div>
                </div>
                <div className="main-heading">
                  <h4>{t(item.labelKey)}</h4>
                </div>
              </div>
            ))}
          </div>
          <div className="col-md-3">
            <div className="red_btn ">
              <Link to="/contact-us">{t('contact_us')}</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CountryList;
